import { basicPromotion, BASIC_PROMO_CODE } from './basicPromotion';

export type MetaAvatar = 'rental' | 'grandparent' | 'family' | 'comfort' | 'value' | 'fit';
export const META_AVATAR_COPY: Record<MetaAvatar, {pain: string; plan: string; proof: string; proofLink: string}> = {
 rental: {pain: 'A growing guest list. The same floor space.', plan: 'Make room for guests with your selected bunk. Check its footprint, choose your options, and see your full price.', proof: 'See how Bliss bunk rooms make room for guests.', proofLink: 'Explore Bliss bunk rooms'},
 grandparent: {pain: 'More time with the grandkids starts with room for everyone.', plan: 'Make a place for the next family visit. Start with the bunk you liked, check the mattress sizes and room fit, then choose your options.', proof: 'Picture the next family visit in a Bliss bunk room.', proofLink: 'See Bliss rooms for inspiration'},
 family: {pain: 'Everyone is welcome. Finding a bed for everyone is the hard part.', plan: 'Give overnight guests a place of their own. Start with the bunk from your ad, compare sizes, and choose the options that suit your home.', proof: 'See what a dedicated guest space can look like.', proofLink: 'Explore Bliss room inspiration'},
 comfort: {pain: 'Growing guests need more than a spare corner to sleep.', plan: 'Compare mattress lengths, widths and headroom for the people who will stay. Your advertised bunk is selected so you can start with the size that caught your eye.', proof: 'Take a closer look at Bliss bunk-room designs.', proofLink: 'View Bliss bunk rooms'},
 value: {pain: 'More room for guests. A budget you want to keep.', plan: 'Start with your selected Bliss Basic bunk. Choose your options, see the complete price, then review extras before deciding how to pay.', proof: 'See the rooms behind the Bliss name.', proofLink: 'Explore Bliss bunk rooms'},
 fit: {pain: 'You know the room. Now find the bunk that belongs in it.', plan: 'Start with your selected standard-size bunk. Compare its footprint and ladder position, or preview it in your room before choosing your options.', proof: 'Find inspiration in Bliss bunk-room designs.', proofLink: 'See Bliss room designs'},
};
export type MetaAdCreative = {headline: string; choice: number; avatar: MetaAvatar; image: string; crop: [number,number,number,number]};

// Approved BedOctober creative lineup: numeric prefix of existing utm_content.
export const BEDOCTOBER_ADS: Record<string, MetaAdCreative> = {
  "01": {
    "headline": "Save the scramble for breakfast. We got your unexpected guests covered.",
    "choice": 0,
    "avatar": "family",
    "image": "/media/meta-bedoctober/01.webp",
    "crop": [
      0,
      0.45,
      1,
      0.37
    ]
  },
  "02": {
    "headline": "Our prices are Scary Low!",
    "choice": 1,
    "avatar": "value",
    "image": "/media/meta-bedoctober/02.webp",
    "crop": [
      0.025,
      0.29,
      0.95,
      0.42
    ]
  },
  "03": {
    "headline": "We’re never full. Always room for one more.",
    "choice": 2,
    "avatar": "family",
    "image": "/media/meta-bedoctober/03.webp",
    "crop": [
      0.0,
      0.215,
      1,
      0.46
    ]
  },
  "04": {
    "headline": "Low prices for high rises.",
    "choice": 4,
    "avatar": "rental",
    "image": "/media/meta-bedoctober/04.webp",
    "crop": [
      0.028,
      0.377,
      0.944,
      0.42
    ]
  },
  "05": {
    "headline": "Sometimes spreading out means stacking up.",
    "choice": 0,
    "avatar": "family",
    "image": "/media/meta-bedoctober/05.webp",
    "crop": [
      0,
      0.45,
      1,
      0.37
    ]
  },
  "06": {
    "headline": "C’mon Grandma, give the “Okay” on another Vacay!",
    "choice": 1,
    "avatar": "grandparent",
    "image": "/media/meta-bedoctober/06.webp",
    "crop": [
      0.035,
      0.19,
      0.93,
      0.4
    ]
  },
  "07": {
    "headline": "Keep your new couch new. Let us do what we do.",
    "choice": 3,
    "avatar": "family",
    "image": "/media/meta-bedoctober/07.webp",
    "crop": [
      0.0,
      0.175,
      1,
      0.465
    ]
  },
  "08": {
    "headline": "Your guest list grew. Your condo didn’t.",
    "choice": 4,
    "avatar": "rental",
    "image": "/media/meta-bedoctober/08.webp",
    "crop": [
      0.035,
      0.47,
      0.93,
      0.345
    ]
  },
  "09": {
    "headline": "Freestanding or Built-In… your freedom to choose!",
    "choice": 0,
    "avatar": "fit",
    "image": "/media/meta-bedoctober/09.webp",
    "crop": [
      0.0,
      0.34,
      1,
      0.425
    ]
  },
  "10": {
    "headline": "Twins for ALL generations",
    "choice": 1,
    "avatar": "grandparent",
    "image": "/media/meta-bedoctober/10.webp",
    "crop": [
      0.025,
      0.35,
      0.95,
      0.415
    ]
  },
  "11": {
    "headline": "Who’s got dibs on the top bunk?",
    "choice": 3,
    "avatar": "family",
    "image": "/media/meta-bedoctober/11.webp",
    "crop": [
      0,
      0.18,
      1,
      0.46
    ]
  },
  "12": {
    "headline": "Let’s watch The Hunt for Bed-October!",
    "choice": 4,
    "avatar": "value",
    "image": "/media/meta-bedoctober/12.webp",
    "crop": [
      0.025,
      0.43,
      0.95,
      0.39
    ]
  },
  "13": {
    "headline": "Cousins coming over? No biggie.",
    "choice": 0,
    "avatar": "grandparent",
    "image": "/media/meta-bedoctober/13.webp",
    "crop": [
      0,
      0.325,
      1,
      0.445
    ]
  },
  "14": {
    "headline": "More heads need more beds.",
    "choice": 1,
    "avatar": "rental",
    "image": "/media/meta-bedoctober/14.webp",
    "crop": [
      0.035,
      0.35,
      0.93,
      0.41
    ]
  },
  "15": {
    "headline": "Your spare room just got promoted.",
    "choice": 3,
    "avatar": "rental",
    "image": "/media/meta-bedoctober/15.webp",
    "crop": [
      0.0,
      0.2,
      1,
      0.465
    ]
  },
  "16": {
    "headline": "Bunk beds aren’t just for kids.",
    "choice": 4,
    "avatar": "comfort",
    "image": "/media/meta-bedoctober/16.webp",
    "crop": [
      0.035,
      0.39,
      0.93,
      0.39
    ]
  },
  "17": {
    "headline": "It’s just ME! (+1, +2 and +3)",
    "choice": 4,
    "avatar": "family",
    "image": "/media/meta-bedoctober/17.webp",
    "crop": [
      0.0,
      0.33,
      1,
      0.415
    ]
  },
  "18": {
    "headline": "Cheap tickets + cheap sleep = priceless memories.",
    "choice": 4,
    "avatar": "family",
    "image": "/media/meta-bedoctober/18.webp",
    "crop": [
      0.035,
      0.33,
      0.93,
      0.39
    ]
  },
  "19": {
    "headline": "The Queen is downstairs. I’ll take the Twin XL penthouse suite!",
    "choice": 3,
    "avatar": "comfort",
    "image": "/media/meta-bedoctober/19.webp",
    "crop": [
      0,
      0.19,
      1,
      0.43
    ]
  },
  "20": {
    "headline": "It’s just ME! (+1, +2 and +3)",
    "choice": 5,
    "avatar": "family",
    "image": "/media/meta-bedoctober/20.webp",
    "crop": [
      0,
      0.315,
      1,
      0.435
    ]
  }
};

const META_SOURCES = new Set(['fb', 'ig', 'facebook', 'instagram', 'meta', 'messenger', 'msg', 'an']);

/** Existing BedOctober ads already carry these tags. A click ID alone does not
 * identify a product, and unrelated Meta campaigns must keep their own flow. */
export function metaBasicEntry(search: string, now = Date.now()) {
  const query = new URLSearchParams(search);
  const source = (query.get('utm_source') || '').toLowerCase();
  const campaign = (query.get('utm_campaign') || '').toLowerCase();
  const taggedBedOctober = META_SOURCES.has(source)
    && query.get('utm_medium')?.toLowerCase() === 'paid_social'
    && campaign === 'bedoctober_2026';
  const explicitBasic = query.get('flow') === 'meta-basic';
  if (!taggedBedOctober && !explicitBasic) return null;

  // This only preselects an existing public offer. Checkout still validates it
  // server-side; an expired campaign must never advertise or grant a discount.
  let promoCode = '';
  if (taggedBedOctober || (explicitBasic && query.get('offer')?.toUpperCase() === BASIC_PROMO_CODE)) {
    try { promoCode = basicPromotion(BASIC_PROMO_CODE, 'basic', 1, now)?.code || ''; }
    catch { /* Keep the Basic route at regular pricing after expiry. */ }
  }
  const adId = /^(\d{2})(?:_|$)/.exec(query.get('utm_content') || '')?.[1];
  const ad = taggedBedOctober && adId ? BEDOCTOBER_ADS[adId] : undefined;
  return { promoCode, headline: ad?.headline, choice: ad?.choice ?? 0, creative: ad };
}

